import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class ConfirmationModal extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { show, message, onSubmit, onCancel } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Modal show={show} onHide={onCancel} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Override Collector Settings and Resubmit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary pull-right" onClick={onSubmit}>Submit</Button>
          <Button bsStyle="link pull-left" onClick={onCancel}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ConfirmationModal;
